var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7499 8.26826C21.7499 7.87044 21.5919 7.48891 21.3106 7.20761C21.0292 6.92631 20.6477 6.76827 20.2499 6.76827H1.49999C1.10217 6.76827 0.720641 6.92631 0.439338 7.20761C0.158035 7.48891 0 7.87044 0 8.26826C0 8.66609 0.158035 9.04762 0.439338 9.32892C0.720641 9.61022 1.10217 9.76826 1.49999 9.76826H20.2499C20.6477 9.76826 21.0292 9.61022 21.3106 9.32892C21.5919 9.04762 21.7499 8.66609 21.7499 8.26826Z",
    fill: "url(#paint0_linear_3144_251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 8.26839C24 7.8706 23.8419 7.48913 23.5606 7.2079L16.8106 0.45793C16.6722 0.314666 16.5067 0.200393 16.3237 0.12178C16.1407 0.0431666 15.9439 0.00178735 15.7447 5.66343e-05C15.5455 -0.00167408 15.348 0.0362787 15.1637 0.1117C14.9793 0.187121 14.8119 0.2985 14.671 0.439338C14.5302 0.580176 14.4188 0.747654 14.3434 0.931997C14.268 1.11634 14.23 1.31386 14.2317 1.51303C14.2335 1.71219 14.2749 1.90902 14.3535 2.09203C14.4321 2.27503 14.5464 2.44055 14.6896 2.57892L20.3791 8.26839L14.6896 13.9579C14.4082 14.2391 14.25 14.6207 14.2498 15.0186C14.2497 15.4165 14.4076 15.7981 14.6889 16.0796C14.9701 16.3611 15.3517 16.5193 15.7496 16.5194C16.1475 16.5195 16.5291 16.3616 16.8106 16.0804L23.5606 9.33038C23.7001 9.19095 23.8107 9.02538 23.8861 8.84315C23.9615 8.66092 24.0002 8.46561 24.0001 8.26839Z",
    fill: "url(#paint1_linear_3144_251)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3144_251",
    x1: 0,
    y1: 8.26826,
    x2: 21.7499,
    y2: 8.26826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3144_251",
    x1: 14.2317,
    y1: 8.2597,
    x2: 24.0001,
    y2: 8.2597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.cc7406a0f5205693a7c730a6e6ac2c29.svg";
export { ForwardRef as ReactComponent };